import { render } from "./Member.vue?vue&type=template&id=45dcf9aa&scoped=true"
import script from "./Member.vue?vue&type=script&lang=js"
export * from "./Member.vue?vue&type=script&lang=js"

import "./Member.vue?vue&type=style&index=0&id=45dcf9aa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dcf9aa"]])

export default __exports__